export const USER_AGENT = "user-agent";
export const X_REFERER = "x-referer";
export const X_USER_AGENT = `x-${USER_AGENT}`;
export const X_API_KEY = "x-api-key";
export const X_ATTACHMENT_KEY = "x-attachment-key";
